import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { forms as Forms } from '@breezeway/brzw-components';

import './redux_form_select.scss';

const CLASS_NAME = 'redux-form-select';

const ReduxFormSelect = ({
  className,
  input: { onChange, value },
  label,
  meta: { error },
  options,
  placeholder,
  required,
  errorWithText,
}) => {
  const onSelect = option => {
    onChange(option.value);
  };

  return (
    <>
      <Forms.Select
        className={classnames(CLASS_NAME, className)}
        isRequired={required}
        labelText={label}
        onSelect={onSelect}
        options={options}
        placeholderText={placeholder}
        value={value}
        withError={error}
      />
      {error && errorWithText && <div className={`${CLASS_NAME}__error-text`}>{error}</div>}
    </>
  );
};

ReduxFormSelect.propTypes = {
  className: PropTypes.string,
  errorWithText: PropTypes.bool,
  input: PropTypes.shape({
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  }),
  label: PropTypes.string,
  meta: PropTypes.shape({
    error: PropTypes.string,
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    }),
  ),
  placeholder: PropTypes.string,
  required: PropTypes.bool,
};

export default ReduxFormSelect;
